<ng-container *ngIf="snapProduct !== 'custom'">
    <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : 'popup'">
        <div class="part1">
            <p [innerHTML]="popUpParameter"></p>
            <div class="DataLabel-Container-Main" *ngIf="visualization == 'Line Chart' ">
                <div class="DataLabel-Container-text">Data Label</div>
                <div class="DataLabel-Container">
                    <div [style]="DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOnClick()">On</div>
                    <div [style]="!DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOffClick()">Off</div>
                </div>
            </div>
            <div class="Top10-All-Container" *ngIf="Top10Container==true">
                <div class="Top10-Block" [ngClass]="{'ToggleActive':Top10Toggle}" (click)="Top10selected()">
                    Top 10
                </div>
                <div class="All-Block" [ngClass]="{'ToggleActive':!Top10Toggle}" (click)="Allselected()">
                    All
                </div>
            </div>
            <div class="ribbon-actions-container">
                <div class="trend-icon-button-wrapper" *ngIf="block?.mcode === 1 || _chatbotexpandComponent.mcode === 1">
                    <div class="trend-container" [class.active]="block.isTrendActive"
                        (click)="_chatbotexpandComponent.onTrendToggle(block)">
                        <div class="trend-icon" [style.background-image]="block.isTrendActive ? 'url(assets/images/common/aesthetics/crosstab_verticalgroup_bar_InActive.svg)' : ''"></div>
                        <span class="trend-text">{{ block.isTrendActive ? 'Standard' : 'Trendline' }}</span>
                    </div>
                </div>

                <!-- Download Button (exports-popup-container) -->
                <div class="exports-popup-container" #exportsPopup
                    *ngIf="_chatbotexpandComponent.isActionsVisible(block)">
                    <div class="exports-popup-container-img-block"
                        [ngClass]="{ 'exports-popup-container-img-block-Active' : block.isExportspopup}"
                        (click)="_chatbotexpandComponent.Exportspopup($event, block)">
                    </div>
                    <div class="setting-container showPanel"
                        [ngStyle]="{right:_chatbotexpandComponent.isInsightsBtnEnabled && _chatbotexpandComponent.is_AI_Integration?'8.5%':'1%'}"
                        *ngIf="block.isExportspopup">
                        <div class="setting-blocks editablePPTSettings" *ngIf="block?.mcode != 1"
                            [ngClass]="{ 'disabled': !(_chatbotexpandComponent.pptExport && (block.isVerticalGroupBarChartClick || block.isVerticalBarChartClick || block.isVerticalStackChartClick || block.isLineChartClick || _chatbotexpandComponent.isSnapshotVisible(block))) }"
                            (click)="_chatbotexpandComponent.handlePPTExportClick($event, block)">
                            <div class="setting-block-icon ppt-icon"></div>
                            <div class="setting-block-name">PPT</div>
                        </div>
                        <div class="setting-blocks editablePPTSettings" *ngIf="block?.mcode == 1"
                            (click)="_chatbotexpandComponent.handlePPTExportClick($event, block)">
                            <div class="setting-block-icon ppt-icon"></div>
                            <div class="setting-block-name">PPT</div>
                        </div>
                        <div class="setting-blocks excelexportSettings"
                            [ngClass]="{'disabled':!_chatbotexpandComponent.isActionsVisible(block)}"
                            (click)="_chatbotexpandComponent.handleExportClick($event, block)">
                            <div class="setting-block-icon excel-icon"></div>
                            <div class="setting-block-name">Excel</div>
                        </div>
                    </div>
                </div>

                <!-- Selection Summary Button -->
                <button class="selection-summary-btn"
                    *ngIf="_chatbotexpandComponent.isActionsVisible(block)"
                    (click)="_chatbotexpandComponent.SelectionsummaryCollapseExpand('SelectionSummary', block)">
                    Selection Summary
                </button>
            </div>
            <div style="display:flex;align-items:center" class="Icons-Container">
                <img src="../../../../assets/images/snap_output_icons/info.svg" alt="" style="display:none">
                <img src="../../../../assets/images/snap_output_icons/Icon_collapse.svg" alt=""
                    (click)="collapseExandPopup()">
            </div>
        </div>
        <hr>
        <div [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'part2'" style="position: relative;">
            <!-- Copy Chart Button inside chart area -->
            <div class="copy-icon-wrapper tooltip-wrapper" style="position: absolute; bottom: 15px; right: 15px; z-index: 999; cursor: pointer !important;">
              <div class="icon-button copy-icon" (click)="_chatbotexpandComponent.handleCopyChartClick($event, block, _cdref)" style="cursor: pointer; width: 33px; height: 33px; border-radius: 6px; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(0,0,0,0.05); box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                <!-- Default Copy Icon -->
                <svg *ngIf="_chatbotexpandComponent.copiedChartId !== block.messageId && _chatbotexpandComponent.isCopyingId !== block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon" style="pointer-events: none;">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                <!-- Loading Spinner Icon -->
                <svg *ngIf="_chatbotexpandComponent.isCopyingId === block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon spin-animation" style="pointer-events: none;">
                  <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path>
                </svg>
                <!-- Copied Checkmark Icon -->
                <svg *ngIf="_chatbotexpandComponent.copiedChartId === block.messageId && _chatbotexpandComponent.isCopyingId !== block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon copied" style="pointer-events: none;">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div class="askme-custom-tooltip feedback-tooltip" style="pointer-events: none;">
                <span class="d-title">{{ _chatbotexpandComponent.copiedChartId === block.messageId ? 'Copied!' : 'Copy chart' }}</span>
              </div>
            </div>
            <app-snapshot-chartsparent style="width: 98%; height: 100%;" *ngIf="item.metric.length>0" [popUp]="true"
                [chart]="visualization" [id]="id" [data]="data" [height]="'100%'" [Top10Toggle]="Top10Toggle"
                [DataLabelOn]="DataLabelOn" [brandSelected]="brandSelected" [metricSelected]="metricSelected"></app-snapshot-chartsparent>
            <div class="chart-section-text" *ngIf="item.metric.length<1">
                <div *ngIf="item.metric.length<1 && item.noData==undefined">Widget is not configured.</div>
                <div *ngIf="item.metric.length<1 && item.noData==true">No data available for the selection.</div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="snapProduct == 'custom' && visualization != 'multi'">
    <div [ngClass]="(showSnapshotARK || visualization === 'Line Chart') ? 'popup-snapshot' : 'popup'">

        <!-- Extra Selections Controls (Standard View) -->
        <div class="extraSelections" *ngIf="showSnapshotARK && visualization != 'Line Chart'">
            <div class="sigIndexArea">
                <div class="sigArea">
                    <div style="display:flex;position:relative;width:100%;height:100%;align-items: center;justify-content: center;"
                        [ngClass]="{'initialSelected': isSigSelected}" (click)="select('sig',$event)">
                        <p style="width:100%;text-align: center; font-size: 0.75rem;" class="btn-text">Sig</p>
                    </div>
                </div>
                <div class="indexArea">
                    <div style="display:flex;position:relative;width:100%;height:100%;align-items: center;"
                        [ngClass]="{'initialSelected': isIndexSelected}" (click)="select('index',$event)">
                        <p style="width:100%;text-align: center;font-size: 0.75rem;" class="btn-text">Index</p>
                    </div>
                </div>
            </div>

            <div class="dropdown-container">
                <div class="significanceDropdown" *ngIf="sigConBaseToggle">
                    <div>Significance</div>
                    <div class="significance-dropdown-outer-body">
                        <div class="dd" (click)="onSignificanceDropdown($event)" [title]="displaySignificance">
                            <p class="dropdown-btn-text">{{displaySignificance}}</p>
                            <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': significanceDropdownToggle}">
                            </div>
                        </div>
                        <div *ngIf="significanceDropdownToggle" class="b show-dropdown">
                            <div *ngFor="let item of significanceVal" class="dropdown-values" [ngClass]="{
                                    'selected-item': displaySignificance === item.key,
                                    'disabled': item.key === 'Pairwise' || item.key === 'Reference'
                                }" (click)="significanceSelected1(item,$event)">
                                <div style="display:flex; width:100%;position:relative">
                                    <div class="itemData" title="{{item.key}}">
                                        <span class="dropdown-text-values">{{item.key}}</span>
                                    </div>
                                    <div class="reference-icon-style" *ngIf="item.key=='Reference'">
                                        <div [ngClass]=" !displayBrand ? 'Down-Arrow-reference' : 'Up-Arrow-reference'">
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="item.key=='Reference' && displayBrand" (click)="$event.stopPropagation()"
                                    class="mainBrandDiv sig-ref-dropdown-container show-dropdown">
                                    <div class="sig-ref-main-panel">
                                        <div class="search-row-block-significance" (click)="searchBoxClick($event)">
                                            <input type="text" [(ngModel)]="searchQuery" class="searchInput"
                                                placeholder="Search" />
                                            <div class="search-icon"></div>
                                        </div>
                                        <div class="sig-ref-dropdown-block">
                                            <ng-container *ngFor="let b of allSigBrands; let i = index">
                                                <div *ngIf="!b.hasNextLevel"
                                                    class="sig-ref-dropdown-values sig-ref-flat-item"
                                                    (click)="brandSig(b,$event)"
                                                    [ngClass]="{'selected-item': selectedReference === b}"
                                                    [title]="b.MetricOption">
                                                    <div class="sig-ref-radio-container">
                                                        <input type="radio" name="sig-section" [value]="b.MetricOption"
                                                            [checked]="b.isSelected" class="inputValues">
                                                    </div>
                                                    <div class="sig-brandPara">{{b.MetricOption}}</div>
                                                </div>
                                                <div *ngIf="b.hasNextLevel"
                                                    class="sig-ref-dropdown-values sig-ref-expandable-item"
                                                    [ngClass]="{'expanded': selectedSigAudienceLevel1 === b}"
                                                    (click)="toggleSigAudienceLevel1Expansion(b, $event)"
                                                    [title]="b.MetricOption">
                                                    <div class="sig-brandPara">{{b.MetricOption}}</div>
                                                    <div class="sig-ref-arrow-container"
                                                        [style.transform]="b.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'">
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <!-- Side Panel for Significance Level2 items -->
                                    <div *ngIf="selectedSigAudienceLevel1" class="sig-ref-side-panel">
                                        <div class="sig-ref-side-panel-header">
                                            <span>{{selectedSigAudienceLevel1.MetricOption}}</span>
                                            <span class="sig-ref-close-btn"
                                                (click)="selectedSigAudienceLevel1 = null">✕</span>
                                        </div>
                                        <div class="sig-ref-dropdown-block">
                                            <div *ngFor="let level2Item of selectedSigAudienceLevel1.Level2_children"
                                                [hidden]="searchQuery && !level2Item.Level2_value.toLowerCase().includes(searchQuery.toLowerCase())"
                                                class="sig-ref-dropdown-values sig-ref-level2-item"
                                                (click)="selectSigAudienceLevel2(selectedSigAudienceLevel1, level2Item, $event)"
                                                [ngClass]="{'selected-item': selectedSigBrand?.MetricOption === level2Item.Level2_value}"
                                                [title]="level2Item.Level2_value">
                                                <div class="sig-ref-radio-container">
                                                    <input type="radio" name="sig-level2-section"
                                                        [value]="level2Item.Level2_value"
                                                        [checked]="selectedSigBrand?.MetricOption === level2Item.Level2_value"
                                                        class="inputValues">
                                                </div>
                                                <div class="sig-brandPara">{{level2Item.Level2_value}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="confidenceLeveldropdown DNN" (click)="onCLclick()" *ngIf="sigConBaseToggle"
                    [ngClass]="(displaySignificance !== 'None') ? 'enabled' : 'disabled'">
                    <div>Confidence Level </div>
                    <div class="confidence-level-outer-body">
                        <div class="dd" (click)="onConfidenceLevelDropdown($event)" [title]="displayConfidenceLevel">
                            <p class="dropdown-btn-text">{{displayConfidenceLevel}}</p>
                            <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': ConfidenceLevelDropDownToggle}">
                            </div>
                        </div>
                        <div *ngIf="ConfidenceLevelDropDownToggle" class="Confidence-level-dropdown show-dropdown">
                            <div *ngFor="let level of confidenceLevel" class="dropdown-values"
                                [ngClass]="{'selected-item': displayConfidenceLevel === level.key}"
                                (click)="confidenceLevelSelected(level,$event)">
                                <div style="display:flex; width:100%;position:relative">
                                    <div class="itemData" title="{{level.key}}">
                                        <span class="dropdown-text-values">{{level.key}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="baseDropdown" *ngIf="!sigConBaseToggle" [class.disabled]="isIndexSelected">
                    <div>Reference</div>
                    <div class="reference-dropdown-outer-body">
                        <div class="dd" (click)="onReferenceDropdown($event)" [title]="displayReference">
                            <p class="brandDisplayDiv">{{displayReference}}</p>
                            <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': referenceDropdownToggle}"></div>
                        </div>
                        <div *ngIf="referenceDropdownToggle" class="ref ref-dropdown-container show-dropdown"
                            (click)="$event.stopPropagation()">
                            <div class="ref-main-panel">
                                <div class="search-row-block" (click)="searchBoxClick($event)">
                                    <input type="text" [(ngModel)]="searchQuery" class="searchInput"
                                        placeholder="Search" />
                                    <div class="search-icon"></div>
                                </div>
                                <div class="reference-dropdown-block">
                                    <ng-container *ngFor="let brand of allbrands; let i = index">
                                        <div *ngIf="!brand.hasNextLevel" class="ref-dropdown-values ref-flat-item"
                                            (click)="referenceSelected(brand,$event)"
                                            [ngClass]="{'selected-item': selectedReference === brand}"
                                            [title]="brand.MetricOption">
                                            <div class="ref-radio-container">
                                                <input type="radio" name="section" [value]="brand.MetricOption"
                                                    [checked]="brand.isSelected" class="inputValues">
                                            </div>
                                            <div class="brandPara">{{brand.MetricOption}}</div>
                                        </div>
                                        <div *ngIf="brand.hasNextLevel" class="ref-dropdown-values ref-expandable-item"
                                            [ngClass]="{'expanded': selectedAudienceLevel1 === brand}"
                                            (click)="toggleAudienceLevel1Expansion(brand, $event)"
                                            [title]="brand.MetricOption">
                                            <div class="brandPara">{{brand.MetricOption}}</div>
                                            <div class="ref-arrow-container"
                                                [style.transform]="brand.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'">
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <!-- Side Panel for Reference Level2 items -->
                            <div *ngIf="selectedAudienceLevel1" class="ref-side-panel">
                                <div class="ref-side-panel-header">
                                    <span>{{selectedAudienceLevel1.MetricOption}}</span>
                                    <span class="ref-close-btn" (click)="selectedAudienceLevel1 = null">✕</span>
                                </div>
                                <div class="reference-dropdown-block">
                                    <div *ngFor="let level2Item of selectedAudienceLevel1.Level2_children"
                                        [hidden]="searchQuery && !level2Item.Level2_value.toLowerCase().includes(searchQuery.toLowerCase())"
                                        class="ref-dropdown-values ref-level2-item"
                                        (click)="selectAudienceLevel2(selectedAudienceLevel1, level2Item, $event)"
                                        [ngClass]="{'selected-item': selectedReference?.MetricOption === level2Item.Level2_value}"
                                        [title]="level2Item.Level2_value">
                                        <div class="ref-radio-container">
                                            <input type="radio" name="level2-section" [value]="level2Item.Level2_value"
                                                [checked]="selectedReference?.MetricOption === level2Item.Level2_value"
                                                class="inputValues">
                                        </div>
                                        <div class="brandPara">{{level2Item.Level2_value}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="baseDropdown">
                    <div>Base</div>
                    <div class="base-dropdown-outer-body">
                        <div class="dd" (click)="onBaseDropdown($event)" [title]="baseselected">
                            <p class="dropdown-btn-text">{{baseselected}}</p>
                            <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': BaseDropDownToggle}"></div>
                        </div>
                        <div *ngIf="BaseDropDownToggle && isAnswerBase" class="Base-dropdown show-dropdown">
                            <div *ngFor="let item of base" class="dropdown-values"
                                [ngClass]="{'selected-item': baseselected === item.key}"
                                (click)="baseSelected(item,$event)">
                                <div class="itemData" [title]="item.key">
                                    <span class="dropdown-text-values">{{item.key}}</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="BaseDropDownToggle && !isAnswerBase" class="Base-dropdown show-dropdown">
                            <div *ngFor="let item of base2" class="dropdown-values"
                                [ngClass]="{'selected-item': baseselected === item.key}"
                                (click)="base2Selected(item,$event)">
                                <div class="itemData" [title]="item.key">
                                    <span class="dropdown-text-values">{{item.key}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="weightdropdownContainer">
                    <div>Weight</div>
                    <div class="weighted-dropdown-outer-body">
                        <div class="dd" (click)="onWeightDropdown($event)" [title]="weightSelectedValue">
                            <p class="dropdown-btn-text">{{weightSelectedValue}}</p>
                            <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': weightDropDownToggle}"></div>
                        </div>
                        <div *ngIf="weightDropDownToggle" class="weight-dropdown show-dropdown">
                            <div *ngFor="let item of weight" class="dropdown-values"
                                [ngClass]="{'selected-item': weightSelectedValue === item.key}"
                                (click)="weightSelected(item,$event)">
                                <div class="itemData" [title]="item.key">
                                    <span class="dropdown-text-values">{{item.key}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ribbon-actions-container">
                <div class="trend-icon-button-wrapper" *ngIf="block?.mcode === 1 || _chatbotexpandComponent.mcode === 1">
                    <div class="trend-container" [class.active]="block.isTrendActive"
                        (click)="_chatbotexpandComponent.onTrendToggle(block)">
                        <div class="trend-icon" [style.background-image]="block.isTrendActive ? 'url(assets/images/common/aesthetics/crosstab_verticalgroup_bar_InActive.svg)' : ''"></div>
                        <span class="trend-text">{{ block.isTrendActive ? 'Standard' : 'Trendline' }}</span>
                    </div>
                </div>

                <!-- Download Button (exports-popup-container) -->
                <div class="exports-popup-container" #exportsPopup
                    *ngIf="_chatbotexpandComponent.isActionsVisible(block)">
                    <div class="exports-popup-container-img-block"
                        [ngClass]="{ 'exports-popup-container-img-block-Active' : block.isExportspopup}"
                        (click)="_chatbotexpandComponent.Exportspopup($event, block)">
                    </div>
                    <div class="setting-container showPanel"
                        [ngStyle]="{right:_chatbotexpandComponent.isInsightsBtnEnabled && _chatbotexpandComponent.is_AI_Integration?'8.5%':'1%'}"
                        *ngIf="block.isExportspopup">
                        <div class="setting-blocks editablePPTSettings" *ngIf="block?.mcode != 1"
                            [ngClass]="{ 'disabled': !(_chatbotexpandComponent.pptExport && (block.isVerticalGroupBarChartClick || block.isVerticalBarChartClick || block.isVerticalStackChartClick || block.isLineChartClick || _chatbotexpandComponent.isSnapshotVisible(block))) }"
                            (click)="_chatbotexpandComponent.handlePPTExportClick($event, block)">
                            <div class="setting-block-icon ppt-icon"></div>
                            <div class="setting-block-name">PPT</div>
                        </div>
                        <div class="setting-blocks editablePPTSettings" *ngIf="block?.mcode == 1"
                            (click)="_chatbotexpandComponent.handlePPTExportClick($event, block)">
                            <div class="setting-block-icon ppt-icon"></div>
                            <div class="setting-block-name">PPT</div>
                        </div>
                        <div class="setting-blocks excelexportSettings"
                            [ngClass]="{'disabled':!_chatbotexpandComponent.isActionsVisible(block)}"
                            (click)="_chatbotexpandComponent.handleExportClick($event, block)">
                            <div class="setting-block-icon excel-icon"></div>
                            <div class="setting-block-name">Excel</div>
                        </div>
                    </div>
                </div>

                <!-- Selection Summary Button -->
                <button class="selection-summary-btn"
                    *ngIf="_chatbotexpandComponent.isActionsVisible(block)"
                    (click)="_chatbotexpandComponent.SelectionsummaryCollapseExpand('SelectionSummary', block)">
                    Selection Summary
                </button>
            </div>
        </div>

        <!-- Trendline Controls (Trend/Sample Size/Data Labels) -->
        <div class="extraSelections" *ngIf="visualization == 'Line Chart' && !multiFunnelPopup && isTrendView">
            <div class="dropdowns-conatiner-trend">
                <!-- for only trendline 2 for customsnapshot -->
                <div class="trend-or-samplesize">
                    <div class="toggle-container" (click)="toggleTrendSample('trendview')"
                        [ngClass]="{'Selected':isTrendView}">Trend View</div>
                    <div class="toggle-container" (click)="toggleTrendSample('samplesize')"
                        [ngClass]="{'Selected':isSampleSize}">Sample Size</div>
                </div>
                <div class="view-container" *ngIf="visualization == 'Line Chart' && trendLineView && trendLineView==2 "
                    DocumentClick (DocumentClicked)="closeViewDropdown()">
                    <div class="view-Container-text">View</div>
                    <div class="viewdropdown">
                        <button class="drop-toggle  flat" (click)="toogleViewDropdown()">
                            <span class="selectText"
                                [title]="viewselected">{{(viewselected==""?'Select':viewselected)}}</span>
                            <span class="fa fa-angle-down arrowicon"><img class="downarrow"
                                    [class.rotated]="isviewDropdownOpen"
                                    src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></span>
                        </button>
                        <div class="view-drop-down" *ngIf="isviewDropdownOpen"
                            [ngStyle]="{'padding':viewList.length>0?'4px':'0px','border':viewList.length>0?'1px solid #BABABA':'none'}">
                            <div class="item-container" *ngFor="let item of viewList"
                                [ngClass]="{'selected':item.selected}">
                                <input type="radio" class="checkbox-radio" (click)="viewSelected(item)"
                                    id="{{item.option}}" [checked]="item.selected">
                                <label for="{{item.option}}" class="checkbox-label"
                                    [title]="item.option">{{item.option}}</label><br>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="viewdropdown" *ngIf="visualization == 'Line Chart' && trendLineView && trendLineView==2 "
                    DocumentClick (DocumentClicked)="closeBrandMetricDropdown()">
                    <button class="drop-toggle  flat" (click)="toogleBrandMetricDropdown()">
                        <span class="selectText"
                            [title]="metricSelected">{{(metricSelected==""&&brandSelected==""?'Select':(metricSelected==""?getLastLevel(brandSelected):getLastLevel(metricSelected)))}}</span>
                        <span class="fa fa-angle-down arrowicon"><img class="downarrow"
                                [class.rotated]="toogleBrandMetricDropdownOpen"
                                src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></span>
                    </button>
                    <div class="view-drop-down" *ngIf="toogleBrandMetricDropdownOpen"
                        [ngStyle]="{'padding':BMList.length>0?'4px':'0px','border':BMList.length>0?'1px solid #BABABA':'none'}">
                        <div class="item-container" *ngFor="let item of BMList;let i=index"
                            [ngClass]="{'selected':item.selected}">
                            <input type="radio" class="checkbox-radio" id="{{item.option}}"
                                (click)="brandMetricSelected(item,i)" [checked]="item.selected">
                            <label for="{{item.option}}" class="checkbox-label"
                                [title]="item.option">{{(item.option.includes("|") &&
                                (item.option.split("|")[0].toLowerCase() == "brands" ||
                                item.option.split("|")[0].toLowerCase() == "metric" ||
                                item.option.split("|")[0].toLowerCase() == "audience" ||
                                item.option.split("|")[0].toLowerCase() == "dummy") ? item.option.split("|")[1] :
                                item.option)}}</label><br>
                        </div>
                    </div>
                </div>
                <!-- end of "for only trendline 2 for customsnapshot -->

                <div class="DataLabel-Container-Main" *ngIf="visualization == 'Line Chart' ">
                    <div class="DataLabel-Container-text">Data Label</div>
                    <div class="DataLabel-Container">
                        <div [style]="DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                            class="DataLabelButtons" (click)="DataLabelOnClick()">On</div>
                        <div [style]="!DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                            class="DataLabelButtons" (click)="DataLabelOffClick()">Off</div>
                    </div>
                </div>
            </div>

            <div class="ribbon-actions-container">
                <div class="trend-icon-button-wrapper" *ngIf="block?.mcode === 1 || _chatbotexpandComponent.mcode === 1">
                    <div class="trend-container" [class.active]="block.isTrendActive"
                        (click)="_chatbotexpandComponent.onTrendToggle(block)">
                        <div class="trend-icon" [style.background-image]="block.isTrendActive ? 'url(assets/images/common/aesthetics/crosstab_verticalgroup_bar_InActive.svg)' : ''"></div>
                        <span class="trend-text">{{ block.isTrendActive ? 'Standard' : 'Trendline' }}</span>
                    </div>
                </div>

                <!-- Download Button (exports-popup-container) -->
                <div class="exports-popup-container" #exportsPopup
                    *ngIf="_chatbotexpandComponent.isActionsVisible(block)">
                    <div class="exports-popup-container-img-block"
                        [ngClass]="{ 'exports-popup-container-img-block-Active' : block.isExportspopup}"
                        (click)="_chatbotexpandComponent.Exportspopup($event, block)">
                    </div>
                    <div class="setting-container showPanel"
                        [ngStyle]="{right:_chatbotexpandComponent.isInsightsBtnEnabled && _chatbotexpandComponent.is_AI_Integration?'8.5%':'1%'}"
                        *ngIf="block.isExportspopup">
                        <div class="setting-blocks editablePPTSettings" *ngIf="block?.mcode != 1"
                            [ngClass]="{ 'disabled': !(_chatbotexpandComponent.pptExport && (block.isVerticalGroupBarChartClick || block.isVerticalBarChartClick || block.isVerticalStackChartClick || block.isLineChartClick || _chatbotexpandComponent.isSnapshotVisible(block))) }"
                            (click)="_chatbotexpandComponent.handlePPTExportClick($event, block)">
                            <div class="setting-block-icon ppt-icon"></div>
                            <div class="setting-block-name">PPT</div>
                        </div>
                        <div class="setting-blocks editablePPTSettings" *ngIf="block?.mcode == 1"
                            (click)="_chatbotexpandComponent.handlePPTExportClick($event, block)">
                            <div class="setting-block-icon ppt-icon"></div>
                            <div class="setting-block-name">PPT</div>
                        </div>
                        <div class="setting-blocks excelexportSettings"
                            [ngClass]="{'disabled':!_chatbotexpandComponent.isActionsVisible(block)}"
                            (click)="_chatbotexpandComponent.handleExportClick($event, block)">
                            <div class="setting-block-icon excel-icon"></div>
                            <div class="setting-block-name">Excel</div>
                        </div>
                    </div>
                </div>

                <!-- Selection Summary Button -->
                <button class="selection-summary-btn"
                    *ngIf="_chatbotexpandComponent.isActionsVisible(block)"
                    (click)="_chatbotexpandComponent.SelectionsummaryCollapseExpand('SelectionSummary', block)">
                    Selection Summary
                </button>
            </div>
        </div>

        <div [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'part2'" style="position: relative;">
            <!-- Copy Chart Button inside chart area -->
            <div class="copy-icon-wrapper tooltip-wrapper" style="position: absolute; bottom: 15px; right: 15px; z-index: 10;">
              <div class="icon-button copy-icon" [class.copy-success-pulse]="_chatbotexpandComponent.copiedChartId === block.messageId" (click)="_chatbotexpandComponent.handleCopyChartClick($event, block, _cdref)" style="width: 33px; height: 33px; border-radius: 6px; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(0,0,0,0.05); box-shadow: 0 2px 4px rgba(0,0,0,0.05); transition: all 0.3s ease;">
                <svg *ngIf="_chatbotexpandComponent.copiedChartId !== block.messageId && _chatbotexpandComponent.isCopyingId !== block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon" style="pointer-events: none;">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                <!-- Loading Spinner Icon -->
                <svg *ngIf="_chatbotexpandComponent.isCopyingId === block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon spin-animation" style="pointer-events: none;">
                  <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path>
                </svg>
                <!-- Copied Checkmark Icon -->
                <svg *ngIf="_chatbotexpandComponent.copiedChartId === block.messageId && _chatbotexpandComponent.isCopyingId !== block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon copied copied-checkmark" style="pointer-events: none; transform-origin: center;">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div class="askme-custom-tooltip feedback-tooltip">
                <span class="d-title">{{ _chatbotexpandComponent.copiedChartId === block.messageId ? 'Copied!' : 'Copy chart' }}</span>
              </div>
            </div>
            <!-- Trend View content -->
            <ng-container *ngIf="isTrendView || visualization != 'Line Chart'">
                <!-- Brand Funnel Dropdown (Isolated - Reference Aligned Structure) -->
                <div class="extraSelections brandFunnelRow" *ngIf="isBrandFunnelDropdown && !isTrendActive"
                    style="position: absolute; top: 5px; right: 10px; z-index: 10; border-bottom: none; background: transparent; width: auto; min-height: auto;">
                    <div class="baseDropdown">
                        <div class="base-dropdown-outer-body branddropdown">
                            <button class="drop-toggle btn flat" (click)="toggleFunnelBrandDropdown($event)">
                                <span class="selectText" [title]="selectedFunnelBrand?selectedFunnelBrand:'Select'">
                                    {{selectedFunnelBrand || 'Select'}}
                                </span>
                                <p class="arrowicon">
                                    <img class="downarrow" [class.rotated]="isFunnelBrandDropdownOpen"
                                        src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg">
                                </p>
                            </button>
                            <div class="additonal-drop-down" *ngIf="isFunnelBrandDropdownOpen">
                                <div class="item-container" *ngFor="let brand of funnelBrands"
                                    [ngClass]="{'selected': selectedFunnelBrand === brand}">
                                    <input type="radio" class="checkbox-radio" [id]="brand"
                                        (click)="selectFunnelBrand(brand, $event)"
                                        [checked]="selectedFunnelBrand === brand">
                                    <label [for]="brand" (click)="selectFunnelBrand(brand, $event)"
                                        class="checkbox-label" [title]="brand">
                                        {{brand}}
                                    </label><br>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <div class="chart-fade-container" *ngIf="isChartVisible">
                    <app-snapshot-chartsparent [snapProduct]="'custom'" style="width: 98%; height: 100%;"
                        [customData]="filteredFunnelData || customData" [isOutput]="true" [popUp]="true" [id]="id"
                        [height]="'100%'" [metricSelected]="metricSelected" [brandSelected]="brandSelected"
                        [Top10Toggle]="Top10Toggle" [DataLabelOn]="DataLabelOn"></app-snapshot-chartsparent>
                </div>

                <div *ngIf="charttype === 'Bubble Chart'" class="note-bottom">
                    <!-- Content for Bubble Chart -->
                    Note: Bubble Radius:{{zAxisMetric}}
                </div>
            </ng-container>

            <!-- Sample Size view content -->
            <div *ngIf="isSampleSize" [ngClass]="visualization === 'Line Chart' ? 'part2-trend-samplesize' : 'part2'"
                style="width: 100%;">
                <app-shared-popup-snapshot *ngIf="isSampleSize" [showSampleSizePopup]="isSampleSize"
                    [showInputPopUp]="false" [showErrorPopUp]="false" [popUpParameter]="'SampleSize'"
                    [OutputdataObject]="OutputdataObject" [snapshotdata]="this.sampleSizeOutputData"
                    [isTranspose]="false" [isTotalBase]="true" [isAnswerBase]="false" [isSampleSize]="isSampleSize"
                    [TrendToggleContainer]="TrendToggleContainer" [TrendToggleOn]="TrendToggleOn"
                    [SnapShotType]="this._configService.selectedSnapshotType"
                    [weightSelectedValue]="weightSelectedValue" [trendSamplesizeview]="true"
                    (toggle)="toggleTrendSample($event)" [isTrendView]="isTrendView">
                </app-shared-popup-snapshot>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="snapProduct == 'custom' && multiFunnelPopup">
    <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : 'multifunnelpopup'">
        <div class="part1">
            <p [innerHTML]="popUpParameter"></p>
            <div class="DataLabel-Container-Main" *ngIf="visualization == 'Line Chart' ">
                <div class="DataLabel-Container-text">Data Label</div>
                <div class="DataLabel-Container">
                    <div [style]="DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOnClick()">On</div>
                    <div [style]="!DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOffClick()">Off</div>
                </div>
            </div>
            <div class="Top10-All-Container" *ngIf="Top10Container==true">
                <div class="Top10-Block" [ngClass]="{'ToggleActive':Top10Toggle}" (click)="Top10selected()">
                    Top 10
                </div>
                <div class="All-Block" [ngClass]="{'ToggleActive':!Top10Toggle}" (click)="Allselected()">
                    All
                </div>
            </div>
            <div style="display:flex;align-items:center" class="Icons-Container">
                <!-- <img src="../../../../assets/images/snap_output_icons/info.svg" alt="" style="display:none">
                <img src="../../../../assets/images/snap_output_icons/Icon_collapse.svg" alt=""
                    (click)="collapseExandPopup()"> -->
                <div class="close-icon" (click)="collapseExandPopup()"></div>
            </div>
        </div>
        <hr>
        <div [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'multifunnelpart2'" style="position: relative;">
            <!-- Copy Chart Button inside chart area -->
            <div class="copy-icon-wrapper tooltip-wrapper" style="position: absolute; bottom: 15px; right: 15px; z-index: 10;">
              <div class="icon-button copy-icon" [class.copy-success-pulse]="_chatbotexpandComponent.copiedChartId === block.messageId" (click)="_chatbotexpandComponent.handleCopyChartClick($event, block, _cdref)" style="width: 33px; height: 33px; border-radius: 6px; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(0,0,0,0.05); box-shadow: 0 2px 4px rgba(0,0,0,0.05); transition: all 0.3s ease;">
                <svg *ngIf="_chatbotexpandComponent.copiedChartId !== block.messageId && _chatbotexpandComponent.isCopyingId !== block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon" style="pointer-events: none;">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                <!-- Loading Spinner Icon -->
                <svg *ngIf="_chatbotexpandComponent.isCopyingId === block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon spin-animation" style="pointer-events: none;">
                  <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path>
                </svg>
                <!-- Copied Checkmark Icon -->
                <svg *ngIf="_chatbotexpandComponent.copiedChartId === block.messageId && _chatbotexpandComponent.isCopyingId !== block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon copied copied-checkmark" style="pointer-events: none; transform-origin: center;">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div class="askme-custom-tooltip feedback-tooltip">
                <span class="d-title">{{ _chatbotexpandComponent.copiedChartId === block.messageId ? 'Copied!' : 'Copy chart' }}</span>
              </div>
            </div>
            <!-- <app-snapshot-chartsparent [snapProduct]="'custom'"  style="width: 98%; height: 100%;"
            [customData]="customData" [isOutput]="true" [popUp]="true"  [height]="'22em'"></app-snapshot-chartsparent> -->
            <div class="grid-container">
                <div class="grid-item" [ngStyle]="{'width': (i % 3 === 0) ? 'auto' : 'auto'}"
                    *ngFor="let cell of gridData;let i=index">
                    <h3>{{cell.header}}</h3>
                    <hr>
                    <!-- <app-snapshot-chartsparent [snapProduct]="'custom'"  style="width: 98%; height: 100%;"
                  [customData]="customData" [isOutput]="false" [popUp]="true"  [height]="'10em'"></app-snapshot-chartsparent> -->
                    <app-funnelchart1-custom *ngIf="customData.widgetchart_name=='FUNNEL CHART'"
                        [selectedBrand]="cell.header" [isOutput]="true" [multiFunnelPopup]="multiFunnelPopup"
                        [popUp]="false" [customData]="cell.data" [id]="id + '_' + (i+90)" [height]="'13em'"
                        [gridTempleteColumns]="''" [showXaxisLabels]="i%3==0?true:false"></app-funnelchart1-custom>
                </div>
            </div>
        </div>
    </div>

</ng-container>